
export default {
  props: {
    color: {
      type: String,
      default: '#7d9fb6'
    }
  },
  computed: {
    fill() {
      return this.$vuetify.theme.isDark ? '#121212' : '#fff'
    }
  }
}
